
<router-outlet *ngIf="isLiberado()"></router-outlet>
